function isEllipsisActive(element, offset = 0) {
  return element.offsetWidth < element.scrollWidth - offset || element.offsetHeight < element.scrollHeight - offset;
}

export { isEllipsisActive };
//# sourceMappingURL=element.mjs.map
